// import getUpdateCurrencyConversionRateColumns from '@Modules/admin/basicSettings/components/reactTable/columns/updateCurrencyConversionRate/Columns';
// import { TMyData } from '@Modules/admin/basicSettings/components/reactTable/columns/updateCurrencyConversionRate/FakeData';
import { IUpdateCurrencyConversionRateFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/currency/updateCurrencyConversionRate/UpdateCurrencyConversionRateMeta';
import { CustomButton, CustomTextInput } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
// import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import React from 'react';
import { useForm } from "react-hook-form";
import { FaSave } from "react-icons/fa";

// let itemsList = [
//     {}, {}, {}, {}, 
//   ]

type Props = {
  onSubmit: any,
  meta: IUpdateCurrencyConversionRateFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const UpdateCurrencyConversionRateFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

  const {
      register,
      handleSubmit,
      formState: { errors },
      // setValue,
      getValues
    } = useForm({ resolver: yupResolver(meta.schema) });
    
  return (
    <>
        <CC.Heading as='h1' size={'md'} fontWeight="Bold" mb={'10'}>
            Mise à jour des taux de conversion
        </CC.Heading>
        <CC.Box w={'100%'} as={"form"} onSubmit={handleSubmit(onSubmit)}>
            <CC.Card p={5} mb={10}>
                <CC.Heading as='h3' size={'md'} fontWeight="normal" mb={'3'}>
                  Devise
                </CC.Heading>
                <CC.Grid templateColumns={{base: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)'}} gap={5}>
                    <CustomFormControl
                        label={meta.myId.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.myId.name]}
                    >
                        <CustomTextInput meta={meta.myId}  register={register(meta.myId.name)} hasError={errors[meta.myId.name]} />
                    </CustomFormControl> 
                    <CustomFormControl
                        label={meta.name.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.name.name]}
                    >
                        <CustomTextInput meta={meta.name}  register={register(meta.name.name)} hasError={errors[meta.name.name]} />
                    </CustomFormControl>                
                </CC.Grid>
            </CC.Card>

            {/* <CustomReactTable data={data} columns={columns} /> */}

            

            <CC.HStack my={6} justifyContent={'flex-end'}>
                <CustomButton isLoading={isSubmitting} type={"submit"}><FaSave style={{marginRight: '10px'}} /> Enregistrer</CustomButton>
            </CC.HStack>

        </CC.Box>
    </>    
  )
}

export default UpdateCurrencyConversionRateFormUI;